import createVueApp from '@/common/createApp'

// Styxie derives the name from Admin::Moments::PromptsController → AdminMomentsPrompts,
// and every key is a controller action. A key that does not match the action renders
// the page chrome and never mounts Vue, with no error anywhere — hence the spec.
Styxie.Initializers.AdminMomentsPrompts = {
  index: async(props) => {
    const { default: IndexPage } = await import('@/vue_widgets/admin/moments/prompts/index.vue')
    createVueApp(IndexPage, { props })
  },
  new: async(props) => {
    const { default: NewPage } = await import('@/vue_widgets/admin/moments/prompts/new.vue')
    createVueApp(NewPage, { props })
  },
  edit: async(props) => {
    const { default: EditPage } = await import('@/vue_widgets/admin/moments/prompts/edit.vue')
    createVueApp(EditPage, { props })
  }
}
